import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import One from "./One";
import Two from "./Two";
import Three from "./Three";
import { ArrowForward } from "@mui/icons-material";
import Four from "./Four";
import Five from "./Five";

const items = [
  {
    title: 'From Testing to Business Value',
    info: 'Prioritize what matters with risk-based insights and production-driven testing strategies.',
    component: () => <One />
  },
  {
    title: 'Automation without Limits',
    info: 'Native CI/CD integrations for effortless execution and scaling of automated tests.',
    component: () => <Two />
  },
  {
    title: 'Smarter Decisions, Faster',
    info: 'Advanced analytics and predictive dashboards that empower your team to deliver quality at speed.',
    component: () => <Three />
  },
  {
    title: 'Collaboration at Its Core',
    info: 'Break silos with real-time workflows connecting your entire team - developers, testers, and product owners.',
    component: () => <Four />
  },
  {
    title: 'One Platform for Every Need',
    info: ' Manual, automated, and exploratory testing - unified and scalable for enterprises.',
    component: () => <Five />
  }
]

const BannerText = () => {
  return (
    <Container fluid className="py-5 banner-text">
      <Row>
        <Col>
          <p className="banner-heading" style={{ lineHeight: '60px' }}>
            <span className="powered">
              GAINSS:{" "}
              <span className="automation">
                Accelerate Quality, Elevate Testing
              </span>
            </span>
          </p>
          {/* <p className="banner-para">
          An AI Native test intelligence and performance engineering platform designed for engineering leaders, heads of testing, test managers, and testers. GAINSS drives smarter decisions, faster execution, and measurable impact for your software quality lifecycle.
          </p> */}
        </Col>
      </Row>
      {
        items.map(item => (
          <Row key={item.title}>
            <Col className="d-flex align-items-center">
              <div className="p-2 pb-3">
                {item.component()} {" "}
              </div>
              <div>

                <p className="text-standard ml-2">
                  <strong>{item.title} </strong><br />
                  {item.info}
                </p>
              </div>

            </Col>
          </Row>
        ))
      }

      <Row className="mt-2">
        <Col>
          <a
            target="=_blank"
            href="https://calendly.com/vikas-mittal "
            className="btn-rounded hire-expert btn btn-primary"
            variant="outline-primary"
          >
            Book a Demo <ArrowForward fontSize="18px" />
          </a>
          {/* <Button variant="outline-primary" className="btn-rounded get-in-touch">
            Get In Touch <ArrowForward fontSize="18px" />
          </Button> */}
        </Col>
      </Row>
    </Container>
  );
};

export default BannerText;
